import React from 'react';
import { Container } from './ui/Container';
import { CheckCircle } from 'lucide-react';
export function JourneyTimelineSection() {
  return <section className="py-20 bg-blue-900 text-white overflow-hidden relative" data-id="element-234">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-235">
        <div className="absolute top-0 left-0 w-96 h-96 bg-blue-400 rounded-full blur-3xl transform -translate-x-1/2 -translate-y-1/2" data-id="element-236"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-purple-500 rounded-full blur-3xl transform translate-x-1/2 translate-y-1/2" data-id="element-237"></div>
      </div>

      <Container className="relative z-10" data-id="element-238">
        <div className="text-center mb-16" data-id="element-239">
          <h2 className="text-3xl md:text-5xl font-extrabold mb-4" data-id="element-240">
            Your Sleep Transformation Timeline
          </h2>
          <p className="text-xl text-blue-200" data-id="element-241">
            What to expect when you start tonight
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-242">
          {[{
          week: 'Week 1',
          title: 'Noticeable Reduction',
          desc: 'Snoring volume drops significantly. Your partner starts sleeping through the night.',
          image: 'https://images.unsplash.com/photo-1531353826977-0941b4779a1c?w=800&q=80'
        }, {
          week: 'Week 2',
          title: 'Deeper Rest',
          desc: 'You wake up feeling truly rested for the first time in years. Brain fog clears.',
          image: 'https://images.unsplash.com/photo-1470252649378-9c29740c9fa8?w=800&q=80'
        }, {
          week: 'Week 3',
          title: 'Relationship Reset',
          desc: 'No more morning resentment. You’re sleeping in the same bed comfortably.',
          image: 'https://images.unsplash.com/photo-1573497620053-ea5300f94f21?w=800&q=80'
        }, {
          week: 'Week 4',
          title: 'Total Transformation',
          desc: 'Silent sleep is the new normal. Energy, mood, and intimacy are fully restored.',
          image: 'https://images.unsplash.com/photo-1516589091380-5d8e87df6999?w=800&q=80'
        }].map((step, index) => <div key={index} className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl overflow-hidden hover:bg-white/20 transition-colors flex flex-col h-full" data-id="element-243">
              <div className="h-40 w-full relative" data-id="element-244">
                <div className="absolute inset-0 bg-blue-900/20 mix-blend-multiply z-10" data-id="element-245"></div>
                <img src={step.image} alt={step.title} className="w-full h-full object-cover" data-id="element-246" />
                <div className="absolute top-4 left-4 z-20" data-id="element-247">
                  <span className="inline-block px-3 py-1 bg-blue-500 text-white text-xs font-bold rounded-full uppercase tracking-wider shadow-lg" data-id="element-248">
                    {step.week}
                  </span>
                </div>
              </div>

              <div className="p-6 flex-grow flex flex-col" data-id="element-249">
                <div className="flex items-center justify-between mb-3" data-id="element-250">
                  <h3 className="text-xl font-bold text-white" data-id="element-251">{step.title}</h3>
                  <CheckCircle className="w-5 h-5 text-green-400 flex-shrink-0" data-id="element-252" />
                </div>
                <p className="text-blue-100 leading-relaxed text-sm" data-id="element-253">
                  {step.desc}
                </p>
              </div>
            </div>)}
        </div>
      </Container>
    </section>;
}